import { create } from "zustand";
import {
    getMyLikedTravelProductIds,
    likeTravelProduct,
    unlikeTravelProduct,
} from "api/travel";

// 투어 찜 ID 캐시. 목록/상세/찜 목록 화면이 같은 하트 상태를 공유한다.
// 사용자별 상태이므로 persist 하지 않고, loadedFor 로 어떤 사용자의 ID 인지 추적한다.
const useTourLikeStore = create((set, get) => ({
    likedIds: new Set(),
    pendingIds: new Set(),
    loadedFor: null,

    loadLikedIds: async (userKey, { force = false } = {}) => {
        if (!userKey) return;
        if (!force && get().loadedFor === userKey) return;
        set({ loadedFor: userKey });
        try {
            const ids = await getMyLikedTravelProductIds();
            if (get().loadedFor === userKey) set({ likedIds: new Set(ids) });
        } catch (err) {
            console.error("getMyLikedTravelProductIds API 에러:", err);
            if (get().loadedFor === userKey) set({ loadedFor: null });
        }
    },

    reset: () => set({ likedIds: new Set(), pendingIds: new Set(), loadedFor: null }),

    // 낙관적 업데이트 후 실패 시 롤백. 성공 여부를 반환한다.
    toggleLike: async (id) => {
        const tourId = Number(id);
        if (get().pendingIds.has(tourId)) return true;

        const wasLiked = get().likedIds.has(tourId);
        const apply = (liked) =>
            set((state) => {
                const next = new Set(state.likedIds);
                if (liked) next.add(tourId);
                else next.delete(tourId);
                return { likedIds: next };
            });
        const setPending = (on) =>
            set((state) => {
                const next = new Set(state.pendingIds);
                if (on) next.add(tourId);
                else next.delete(tourId);
                return { pendingIds: next };
            });

        apply(!wasLiked);
        setPending(true);
        try {
            if (wasLiked) await unlikeTravelProduct(tourId);
            else await likeTravelProduct(tourId);
            return true;
        } catch (err) {
            console.error("toggleTravelProductLike API 에러:", err);
            apply(wasLiked);
            return false;
        } finally {
            setPending(false);
        }
    },
}));

export default useTourLikeStore;
